/**
 * author: Ananthapadmanabhan V K
 */
import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import './CompanyOnboard.scss';
import { Button, Form, input, OverlayTrigger, Popover } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import UtilsService from '../../../core/service/UtilsService';
import CompanyOnboardService from '../../../core/service/CompanyOnboardService';
import { toast } from "react-toastify";
import { useNavigate, useParams } from 'react-router-dom';
import PhoneNumber from '../../../components/PhoneNumber/PhoneNumber';
import { Typeahead } from 'react-bootstrap-typeahead';
import LoginService from '../../../core/service/login-service';
import { SUPPLIER_ADMIN_TXT } from '../../../core/constants/api';
import ErrorHandlingService from '../../../core/service/ErrorHandlingService';
import Header from '../Header/Header';
import { LS_TERMS_AGREED_KEY } from '../../../core/constants/common';
import CompanyService from '../../../core/service/CompanyService';
import ProfileSettingsService from '../../../core/service/ProfileSettingsService';
import { BsInfoCircle } from 'react-icons/bs';
import Multiselect from "multiselect-react-dropdown";
import arrow from '../../../images/arrow.svg';
import { UserContext } from '../../../App';
import useHasPermission from '../../../core/hooks/useHasPermission';

const CompanyOnboard = ({ t }) => {
  var lsAuthorityRolesData = [];
  var lsDat = localStorage.getItem('authority');
  var lsUserData = null;
  var companyName = '';
  var userEmail = '';
  if (lsDat !== "") {
    lsAuthorityRolesData = JSON.parse(lsDat).roles;
  }

  var lsUserDat = localStorage.getItem('userOnboardData');
  if (lsUserDat !== "") {
    lsUserData = JSON.parse(lsUserDat);
    companyName = lsUserData.companyName;
    userEmail = lsUserData.email;
  }
  const navigate = useNavigate();
  const { invite_key } = useParams();
  
  // Permission check for double materiality update
  const { hasDoubleMaterialityUpdatePermission } = useHasPermission();
  const [phoneCodes, setPhoneCodes] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);

  const [legalname, setlegalName] = useState(companyName);
  const [countryoperationalchoosed, setCountryOperationalChoosed] = useState('');
  const [parentcompany, setParentCompany] = useState('');
  const [regnumber, setRegNumber] = useState('');
  const [taxid, setTaxId] = useState('');
  const [contactname, setContactName] = useState('');
  const [designation, setDesignation] = useState('');
  const [email, setEmail] = useState(userEmail);
  // const [contactnumbercode, setContactNumberCode] = useState('');
  // const [contactnumber, setContactNumber] = useState('');
  const [contact, setContact] = useState("");
  const [contactCode, setContactCode] = useState("");
  const [building, setBuilding] = useState('');
  const [street, setStreet] = useState('');
  const [city, setCity] = useState('');
  const [zipcode, setZipcode] = useState('');

  const [currencychoosed, setCurrencyChoosed] = useState('');
  const [countrychoosed, setCountryChoosed] = useState('');
  const [statechoosed, setStateChoosed] = useState('');
  const [validated, setValidated] = useState(false);
  // setEmail(lsUserData.email)
  const [industriesData, setIndustriesData] = useState([]);
  const [industryChoosed, setIndustryChoosed] = useState('');
  const [about, setAbout] = useState('');
  const [frameworks, setFrameworks] = useState('');
  const [goals, setGoals] = useState('');
  const [languages, setLanguages] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [purpose, setPurpose] = useState([]);
  const [purposesList, setPurposesList] = useState([]);
  const [selectedFrameworks, setSelectedFrameworks] = useState([]);
  const [frameworksList, setFrameworksList] = useState([]);
  const [info, setInfo] = useState({
    matIssueCategory: '',
    materialityType: ''
  });
  const [matIssueCategoryList, setMatIssueCategoryList] = useState([]);
  const [apiErrors, setApiErrors] = useState([]);

  useEffect(() => {
    getPhoneCodes();
    getCountry();
    // getStates();
    getCurrency();
    getIndustries();
    getLanguages();
    getESGUtils();
    getMatIssuesCategory();
  }, []);

  const getPhoneCodes = () => {
    UtilsService.getPhoneCodes()
      .then((response) => {
        setPhoneCodes([...response.data]);
      })
      .catch((error) => {
        console.error('Error fetching phone codes:', error);
        setApiErrors(prev => [...prev, { service: 'Phone Codes', error: error.response?.status || 'Network Error' }]);
        if (error.response?.status === 404) {
          toast.error('Phone codes service is not available. Please contact support.', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      });
  };

  const getCountry = () => {
    UtilsService.getCountryList()
      .then((response) => {
        setCountryData([...response.data]);
      })
      .catch((error) => {
        console.error('Error fetching country list:', error);
        if (error.response?.status === 404) {
          toast.error('Country list service is not available. Please contact support.', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      });
  };

  const getStates = (countryId) => {
    UtilsService.getStateList(countryId)
      .then((response) => {
        setStateData([...response.data]);
      })
      .catch((error) => {
        console.error('Error fetching state list:', error);
        if (error.response?.status === 404) {
          toast.error('State list service is not available. Please contact support.', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      });
  };

  const getCurrency = () => {
    UtilsService.getCurrencyList()
      .then((response) => {
        setCurrencyData([...response.data]);
      })
      .catch((error) => {
        console.error('Error fetching currency list:', error);
        if (error.response?.status === 404) {
          toast.error('Currency list service is not available. Please contact support.', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      });
  };

  const getPhoneCodeVal = (data) => {
    if (data.length > 0) {
      setContactCode(data[0].id);
    }
  };

  const getPhoneNumberVal = (data) => {
    setContact(data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      toast.warning('Please fill all the mandatory fields');
    } else if (selectedLanguages.length === 0) {
      toast.warning('Please select at least one language');
      e.stopPropagation();
    } 
    // else if (purpose.length === 0) {
    //   toast.warning('Please select at least one purpose');
    //   e.stopPropagation();
    // } else if (selectedFrameworks.length === 0) {
    //   toast.warning('Please select at least one framework');
    //   e.stopPropagation();
    // } 
    else if (hasDoubleMaterialityUpdatePermission() && !info.matIssueCategory) {
      toast.warning('Please select a material issue category');
      e.stopPropagation();
    } else if (hasDoubleMaterialityUpdatePermission() && !info.materialityType) {
      toast.warning('Please select a materiality type');
      e.stopPropagation();
    } else if (!selectedLanguages.find(language => language.primary)) {
      toast.warning('Please select a default language');
      e.stopPropagation();
    } else {
      submitConfirm();
    }
    setValidated(true);
  }

  const submitConfirm = async (e) => {
    var body = {
      legalName: legalname,
      regNumber: regnumber,
      taxId: taxid,
      parentCompany: parentcompany,
      operationalCountry: {
        id: countryoperationalchoosed
      },
      primaryContact: {
        name: contactname,
        designation: designation,
        email: email,
        contactNumber: {
          code: {
            id: contactCode
          },
          number: contact
        }
      },
      address: {
        building: building,
        street: street,
        zipCode: zipcode,
        city: city,
        state: {
          id: statechoosed
        },
        country: {
          id: countrychoosed
        }
      },
      currency: {
        id: currencychoosed
      },
      industry: {
        id: industryChoosed
      },
      about: about,
      esgFrameworks: frameworks,
      esgGoals: goals,
      languages: selectedLanguages.map(({ id, ...rest }) => rest),
      purposes: purpose,
      frameworks: selectedFrameworks,
      ...(hasDoubleMaterialityUpdatePermission() && {
        materialTopicCategory: info.matIssueCategory,
        materialityType: info.materialityType
      })
    }

    CompanyOnboardService.onboardCompany(invite_key, body)
      .then((response) => {

        if (response.status === 201) {
          localStorage.setItem('userOnboardData', '');
          toast.success('Company onboarded successfully', {
            position: toast.POSITION.TOP_RIGHT,
          });
          checkLoginAuthority(response.data.connectedCompany)
        }
      })
      .catch((error) => {
        console.error('Error during company onboarding:', error);
        if (error.response?.status === 404) {
          toast.error('Invalid or expired invitation key. Please contact your administrator for a new invitation.', {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else if (error.response?.status === 400) {
          toast.error('Invalid company data. Please check all required fields and try again.', {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.error(error.message || 'An error occurred during company onboarding. Please try again.', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      });
  }

  const checkLoginAuthority = async (onboardData) => {
    LoginService.checkAuthority()
      .then((response) => {
        var responseData = response.data.data;
        if (response.status === 200) {
          localStorage.setItem('authority', JSON.stringify(responseData));
          localStorage.setItem(LS_TERMS_AGREED_KEY, responseData?.profile?.user?.termsAgreed ?? true);
          if (responseData.roles.indexOf(SUPPLIER_ADMIN_TXT) > -1) {
            navigate(`/company_admin/supplier_details_onboard/${onboardData.companyId}/${onboardData.supplierDetails.id}`);
          } else {
            navigate("/company_admin/home");
          }

        }
      })
      .catch((error) => {
      });
  };

  const getIndustries = () => {
    CompanyService.getIndustries()
      .then(res => {
        if (res.status !== 200) return;
        setIndustriesData(res.data ?? []);
      })
      .catch(err => {
        console.error('Error fetching industries:', err);
        if (err.response?.status === 404) {
          toast.error('Industries service is not available. Please contact support.', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      });
  };

  const getLanguages = () => {
    CompanyService.getLanguageList()
      .then((response) => {
        setLanguages([...response.data.data]);
      })
      .catch((error) => {
        console.error('Error fetching languages:', error);
        if (error.response?.status === 404) {
          toast.error('Language service is not available. Please contact support.', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      });
  };

  const onSelectDeSelectLanguage = (selectedItem) => {
    setSelectedLanguages((prevSelected) => {
      const isSelected = prevSelected.some(item => item.id === selectedItem.id);

      if (isSelected) {
        return prevSelected.filter(item => item.id !== selectedItem.id);
      } else {
        return [...prevSelected, { ...selectedItem, primary: false }];
      }
    });
  };

  const getESGUtils = () => {
    ProfileSettingsService.getEsgUtils()
      .then(res => {
        if (res.status === 200) {
          setPurposesList(res.data.purposes);
          setFrameworksList(res.data.frameworks);
        }
      })
      .catch(err => {
        console.error('Error fetching ESG utils:', err);
        if (err.response?.status === 404) {
          toast.error('ESG utilities service is not available. Please contact support.', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      });
  };

  const getSelectedPurpose = () => {
    const data = [];
    purposesList?.forEach(pur => {
      if (purpose.indexOf(pur.code) < 0) return;
      data.push(pur);
    });
    return data;
  };

  const onSelectDeSelectPurpose = (selectedItem) => {
    const purposeIds = [...purpose];
    const index = purpose.indexOf(selectedItem.code);
    if (index >= 0) {
      purposeIds.splice(index, 1);
    } else {
      purposeIds.push(selectedItem.code);
    }
    setPurpose(purposeIds);
  };

  const getSelectedFramework = () => {
    const data = [];
    frameworksList?.forEach(frame => {
      if (selectedFrameworks.indexOf(frame.code) < 0) return;
      data.push(frame);
    });
    return data;
  };

  const onSelectDeSelectFramework = (selectedItem) => {
    const frameworkIds = [...selectedFrameworks];
    const index = selectedFrameworks.indexOf(selectedItem.code);
    if (index >= 0) {
      frameworkIds.splice(index, 1);
    } else {
      frameworkIds.push(selectedItem.code);
    }
    setSelectedFrameworks(frameworkIds);
  };

  const getCompatibleFrameWorks = () => {
    const selectedPurposes = getSelectedPurpose();
    const compatibleFrameworks = [];
    selectedPurposes?.forEach(p => {
      p.compatibleFrameworks?.forEach(f => {
        if (compatibleFrameworks?.findIndex(fw => fw.code === f) >= 0) return;

        compatibleFrameworks.push({
          code: f,
          name: f
        });
      });
    });
    return compatibleFrameworks;
  };

  const getMatIssuesCategory = () => {
    CompanyService.getMatIssuesCategory()
      .then(res => {
        if (res.status === 200) {
          setMatIssueCategoryList(res.data.data ?? []);
        }
      })
      .catch(err => {
        console.error('Error fetching material issue categories:', err);
        if (err.response?.status === 404) {
          toast.error('Material issues service is not available. Please contact support.', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      });
  };

  const handleDefaultLanguageChange = (e) => {
    setSelectedLanguages((prevSelected) => {
      return prevSelected.map(language => ({
        ...language,
        primary: language.id === +e.target.value
      }));
    });
  };

  const CustomArrow = ({ isOpen }) => {
    return (
      <img src={arrow} alt="Arrow" />
    );
  };

  return (
    <>
      <Header />
      <div className="page_wrapper_nosidebar">
        <section>
          <div className="Main_body">
            <div className="Company_formBox col-lg-12">
              <div className='List_header'>
                <h5 className='MH'>
                  {t("UserRegistration.label")}
                  {/* {lsAuthorityRolesData.indexOf(SUPPLIER_ADMIN_TXT) > -1 ? (
               <span>{t("SupplierCompany.label")}</span>
              ) : (
                <span>{t("SubscriberCompany.label")}</span>
              )} */}
                </h5>
                {apiErrors.length > 0 && (
                  <div className="alert alert-warning mt-2" role="alert">
                    <strong>API Service Issues Detected:</strong>
                    <ul className="mb-0 mt-1">
                      {apiErrors.map((error, index) => (
                        <li key={index}>{error.service}: {error.error}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
              <p>{t("UserRegistrationSubHead.label")}</p>
              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <div className="row">
                  <div className="Profile_Pic_box">
                    <div className="circle">
                      <img className="profile-pic"
                        src="https://t3.ftcdn.net/jpg/03/46/83/96/360_F_346839683_6nAPzbhpSkIpb8pmAwufkC7c5eD7wYws.jpg" />
                    </div>
                  </div>
                </div>
                <div className="mb-4 row mx-0">
                  <div className="col-lg-6 p-2">
                    <label className="mb-1">{t("orgLegalName.label")} <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" id='legalName' onChange={(e) => setlegalName(e.target.value)}
                      legalname={legalname} value={legalname} required />
                  </div>
                  <div className="col-lg-6 p-2">
                    <label className="mb-1">{t("countryOfOperation.label")} <span className="text-danger">*</span></label>
                    <Typeahead
                      clearButton
                      id="country_op"
                      onChange={(selected) => {
                        if (selected[0]) {
                          setCountryOperationalChoosed(selected[0].id)
                        }
                      }}
                      labelKey={(options) => options.name + '(' + options.code + ')'}
                      options={countryData}
                      inputProps={{ required: true }}
                      placeholder={t("Select.label")}
                    />
                    {/* <Autocomplete
                  disablePortal
                  id="country_op"
                  countryoperationalchoosed={countryoperationalchoosed}
                  options={countryData}
                  getOptionLabel={(options) => options.name + '(' + options.code + ')'}
                  onChange={(event, newValue) => {
                    setCountryOperationalChoosed(newValue.id)
                  }}
                  renderInput={(params) => <TextField {...params} label={t("countryOfOperation.label")} required />}
                /> */}
                  </div>
                  <div className="col-lg-6 p-2">
                    <label className="mb-1">{t("parentCompany.label")}</label>
                    <input type="text" className="form-control" onChange={(e) => setParentCompany(e.target.value)}
                      parentcompany={parentcompany} />
                  </div>
                  <div className="col-lg-6 p-2">
                    <label className="mb-1">{t("compRegNum.label")} </label>
                    <input type="text" className="form-control" onChange={(e) => setRegNumber(e.target.value)}
                      regnumber={regnumber} />
                  </div>
                  <div className="col-lg-6 p-2">
                    <label className="mb-1">{t("taxId.label")}</label>
                    <input type="text" className="form-control" onChange={(e) => setTaxId(e.target.value)}
                      taxid={taxid} />
                  </div>
                  <div className="col-lg-6 p-2">
                    <label className="mb-1">{t("currency.label")}</label>
                    <Typeahead
                      clearButton
                      id="currency"
                      onChange={(selected) => {
                        if (selected[0]) {
                          setCurrencyChoosed(selected[0].id)
                        }
                      }}
                      labelKey={(options) => options.name}
                      options={currencyData}
                      placeholder={t("Select.label")}
                    />
                  </div>
                  <div className="col-lg-6 p-2">
                    <label className="mb-1">
                      {t("Languages.label")}
                      <span className="text-danger ms-1">*</span>
                    </label>
                    <Multiselect
                      id="languageMultiSelect"
                      key="languageMultiSelect"
                      options={languages}
                      selectedValues={selectedLanguages}
                      onSelect={(selectedList, selectedItem) => {
                        onSelectDeSelectLanguage(selectedItem);
                      }}
                      onRemove={(selectedList, selectedItem) => {
                        onSelectDeSelectLanguage(selectedItem);
                      }}
                      placeholder={selectedLanguages.length === 0 ? "Select " : ""}
                      displayValue="name"
                      customArrow={<CustomArrow />}
                      showArrow={true}
                      required
                    />
                  </div>

                  <div className="col-lg-6 p-2">
                    <label className="mb-1">
                      {t("DefaultLanguage.label")} <span className="text-danger">*</span>
                    </label>
                     <select id="defaultLanguageSelector"
                       className="form-select"
                       onChange={handleDefaultLanguageChange}
                       value={selectedLanguages.find(language => language.primary)?.id || ''}
                       required
                      //  disabled={selectedLanguages.length === 0}
                     >
                      <option value='' key='' disabled>{t('Select.label')}</option>
                      {
                        selectedLanguages?.map((lang, index) => {
                          return <option value={lang.id} key={lang.id}>{lang.name}</option>;
                        })
                      }
                    </select>
                  </div>

                  <div className="col-lg-12 p-2">
                    <h6 className="m-0">{t("compAddress.label")}</h6>
                  </div>

                  <div className="col-lg-6 p-2">
                    <label className="mb-1">{t("country.label")} <span className="text-danger">*</span></label>
                    <Typeahead
                      clearButton
                      id="country"
                      onChange={(selected) => {
                        if (selected[0]) {
                          setCountryChoosed(selected[0].id);
                          getStates(selected[0].id);
                        }
                      }}
                      labelKey={(options) => options.name + '(' + options.code + ')'}
                      options={countryData}
                      inputProps={{ required: true }}
                      placeholder={t("Select.label")}
                    />
                  </div>

                  <div className="col-lg-6 p-2">
                    <label className="mb-1">{t("state.label")} <span className="text-danger">*</span></label>
                    <Typeahead
                      clearButton
                      id="state"
                      onChange={(selected) => {
                        if (selected[0]) {
                          setStateChoosed(selected[0].id)
                        }
                      }}
                      labelKey={(options) => options.name}
                      options={stateData}
                      inputProps={{ required: true }}
                      placeholder={t("Select.label")}
                    />
                  </div>

                  <div className="col-lg-6 p-2">
                    <label className="mb-1">{t("city.label")} <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" onChange={(e) => setCity(e.target.value)}
                      city={city} required />
                  </div>

                  <div className="col-lg-6 p-2">
                    <label className="mb-1">{t("street.label")}</label>
                    <input type="text" className="form-control" onChange={(e) => setStreet(e.target.value)}
                      street={street} />
                  </div>

                  <div className="col-lg-6 p-2">
                    <label className="mb-1">{t("building.label")} <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" onChange={(e) => setBuilding(e.target.value)}
                      building={building} required />
                  </div>

                  <div className="col-lg-6 p-2">
                    <label className="mb-1">{t("zipcode.label")}</label>
                    <input type="text" className="form-control" onChange={(e) => setZipcode(e.target.value)}
                      zipcode={zipcode} />
                  </div>

                  <div className="col-lg-12 p-2">
                    <h6 className="m-0">{t("contactPerson.label")}</h6>
                  </div>

                  <div className="col-lg-6 p-2">
                    <label className="mb-1">{t("primaryContactName.label")} <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" onChange={(e) => setContactName(e.target.value)}
                      contactname={contactname} required />
                  </div>

                  <div className="col-lg-6 p-2">
                    <label className="mb-1">{t("primaryContactRole.label")} <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" onChange={(e) => setDesignation(e.target.value)}
                      designation={designation} required />
                  </div>

                  <div className="col-lg-6 p-2">
                    <label className="mb-1">{t("contactEmail.label")} <span className="text-danger">*</span></label>
                    <input type="email" className="form-control" id="email"
                      value={email} required readOnly />
                  </div>

                  <div className="col-lg-6 p-2">
                    <label className="mb-1">{t("ContactNumber.label")} <span className="text-danger">*</span></label>
                    <div className="row px-1">
                      <PhoneNumber
                        onCodeSelected={getPhoneCodeVal}
                        phoneNumber={getPhoneNumberVal}
                        codelabel={t("Select.label")}
                      />
                    </div>
                  </div>

                  <div className="col-lg-12 p-2">
                    <label className="mb-1">{t("Industry.label")} <span className="text-danger">*</span></label>
                    <Typeahead
                      clearButton
                      id="industrySelector"
                      onChange={(selected) => {
                        if (selected[0]) {
                          setIndustryChoosed(selected[0].id);
                        }
                      }}
                      labelKey={(options) => options.name}
                      options={industriesData}
                      inputProps={{ required: true }}
                      placeholder={t("Select.label")}
                    />
                  </div>

                  <div className="col-lg-12 p-2">
                    <label className="mb-1">
                      {t("About.label")}&nbsp;
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Popover id="popover-trigger-hover-focus" className="p-2">
                            <div className="p-1">{t("CompanyAboutHelper.label")}</div>
                          </Popover>
                        }>
                        <span><BsInfoCircle /></span>
                      </OverlayTrigger>
                    </label>
                    <textarea
                      className="form-control"
                      rows={8}
                      maxLength={1800}
                      onChange={(e) => setAbout(e.target.value)}
                      about={about}
                    >
                    </textarea>
                  </div>

                  <div className="col-lg-6 p-2">
                    <label className="mb-1">
                      {t("PurposeOfUsingApp.label")}
                      {/* <span className="text-danger ms-1">*</span> */}
                    </label>
                    <Multiselect
                      id="purposeMultiSelect"
                      key="purposeMultiSelect"
                      options={purposesList}
                      selectedValues={getSelectedPurpose()}
                      onSelect={(selectedList, selectedItem) => {
                        onSelectDeSelectPurpose(selectedItem);
                      }}
                      onRemove={(selectedList, selectedItem) => {
                        onSelectDeSelectPurpose(selectedItem);
                      }}
                      placeholder={getSelectedPurpose().length === 0 ? "Select " : ""}
                      displayValue="name"
                      customArrow={<CustomArrow />}
                      showArrow={true}
                      // required
                    />
                  </div>

                  <div className="col-lg-6 p-2">
                    <label className="mb-1">
                      {t("Framework.label")}
                      {/* <span className="text-danger ms-1">*</span> */}
                    </label>
                    <Multiselect
                      id="frameworkMultiSelect"
                      key="frameworkMultiSelect"
                      options={getSelectedPurpose().length > 0 ? getCompatibleFrameWorks() : frameworksList}
                      selectedValues={getSelectedFramework()}
                      onSelect={(selectedList, selectedItem) => {
                        onSelectDeSelectFramework(selectedItem);
                      }}
                      onRemove={(selectedList, selectedItem) => {
                        onSelectDeSelectFramework(selectedItem);
                      }}
                      placeholder={getSelectedFramework().length === 0 ? "Select " : ""}
                      displayValue="name"
                      customArrow={<CustomArrow />}
                      showArrow={true}
                      // required
                    />
                  </div>

                  {hasDoubleMaterialityUpdatePermission() && (
                    <>
                      <div className="col-lg-6 p-2">
                        <label className="mb-1">
                          {t("MaterialityType.label")}
                          <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select"
                          onChange={(e) => setInfo({ ...info, materialityType: e.target.value })}
                          value={info.materialityType}
                          required
                        >
                          <option value='' key='' disabled>{t('Select.label')}</option>
                          <option value="SINGLE" key="single">Impact Materiality</option>
                          <option value="DOUBLE" key="double">Double Materiality</option>
                        </select>
                      </div>

                      <div className="col-lg-6 p-2">
                        <label className="mb-1">
                          {t("MaterialIssueCategory.label")} <span className="text-danger">*</span>
                        </label>
                        <select id="matIssueCategorySelector"
                          className="form-select"
                          onChange={(e) => setInfo({ ...info, matIssueCategory: e.target.value })}
                          value={info.matIssueCategory}
                          required
                        >
                          <option value='' key='' disabled>{t('Select.label')}</option>
                          {
                            matIssueCategoryList?.map((e, index) => {
                              return <option value={e.name} key={e.id}>{e.name}</option>;
                            })
                          }
                        </select>
                      </div>
                    </>
                  )}

                  <div className="col-lg-12 p-2">
                    <label className="mb-1">{t("ESGFrameworks.label")}&nbsp;
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Popover id="popover-trigger-hover-focus" className="p-2">
                            <div className="p-1">{t("ESGFrameworkHelpText.label")}</div>
                          </Popover>
                        }>
                        <span><BsInfoCircle /></span>
                      </OverlayTrigger>
                    </label>
                    <textarea
                      className="form-control"
                      onChange={(e) => setFrameworks(e.target.value)}
                      frameworks={frameworks}
                    >
                    </textarea>
                  </div>

                  <div className="col-lg-12 p-2">
                    <label className="mb-1">{t("ESGGoals.label")}&nbsp;
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Popover id="popover-trigger-hover-focus" className="p-2">
                            <div className="p-1">{t("ESGGoalsHelpText.label")}</div>
                          </Popover>
                        }>
                        <span><BsInfoCircle /></span>
                      </OverlayTrigger>
                    </label>
                    <textarea
                      rows={8}
                      className="form-control"
                      onChange={(e) => setGoals(e.target.value)}
                      goals={goals}
                    >
                    </textarea>
                  </div>
                </div>

                <div className="text-center">
                  <button type="submit" className="btn btn-primary px-4 sbmBtn">{t("submit.label")}</button>
                </div>
              </Form>
            </div>
          </div>
        </section>
      </div>
    </>
  )
};

export default withTranslation()(CompanyOnboard);
